export const baseGraphqlField = `
    id
    uid
    active
    createdAt
    updatedAt
    deleted
`;

export const baseGraphqlField_ = `
    id
    active
    uid
    createdAt
    updatedAt
    deleted
`;


export const basePageableGraphqlField = `
page {
  number
  hasNextPage
  hasPreviousPage
  currentPageNumber
  nextPageNumber
  previousPageNumber
  numberOfPages
  totalElements
  pagesNumberArray
}
`;

export const baseResponseGraphqlField = `
    response {
        id
        status
        code
       message
      }
`;

export const baseResponse = `
    id
    status
    code
    message
`;



export interface PageResult {
  itemsPerPage: number;
  number?: number;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  currentPageNumber?: number;
  nextPageNumber?: number;
  previousPageNumber?: number;
  numberOfPages?: number;
  totalElements?: number;
  pagesNumberArray?: number[];
}
